export enum ProgressBtnType {
  ADD_TO_BASKET,
  NEXT,
  NONE,
}
